// extracted by mini-css-extract-plugin
module.exports = {"base":"PageNotFound_base__3UikV","status":"PageNotFound_status__m2ccX","content":"PageNotFound_content__1CtPd"};